import { BottomSheet } from "@-/dev.improve.haniverse.components.ui.bottom-sheet";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { ReactNode, Ref } from "react";
import { Linking, View } from "@-/com.npmjs.react-native";

export interface LegalDocumentSheetHandle {
  close: () => void;
  open: () => void;
}

/**
 * A modal bottom sheet that renders a bundled legal document (so it reads offline) above a
 * notice pointing at the always-up-to-date hosted version. The bundled copy is passed as
 * `children` (e.g. `<TermsDocumentBody />`); `latestVersionUrl` is opened in the system
 * browser when the notice link is tapped.
 *
 * Requires a `BottomSheetModalProvider` ancestor (mounted app-wide). Drive it via the
 * imperative `{ open, close }` handle on `ref`.
 */
export function LegalDocumentSheet({
  children,
  latestVersionUrl,
  noticeLeadIn,
  ref,
}: {
  children: ReactNode;
  latestVersionUrl: string;
  noticeLeadIn: string;
  ref?: Ref<LegalDocumentSheetHandle>;
}) {
  return (
    <BottomSheet ref={ref} scrollable={true}>
      <View className="gap-4 pb-2">
        <View className="rounded-xs border border-border bg-muted/30 px-3 py-2">
          <Text className="text-xs text-muted-foreground">
            {noticeLeadIn}
            <Text
              className="text-primary underline"
              onPress={() => void Linking.openURL(latestVersionUrl)}
            >
              {latestVersionUrl}
            </Text>
          </Text>
        </View>
        {children}
      </View>
    </BottomSheet>
  );
}
